import { Modal } from "antd";
import { FC, ReactNode, SetStateAction } from "react";
import { G_Button } from "../Button";
import { G_Text } from "../Text";

interface ActionModalProps {
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<SetStateAction<boolean>>;
  type: "danger" | "normal";
  title?: string;
  description?: string | ReactNode;
  actionLabel?: string;
  action?: () => void;
  loading: boolean;
  children?: ReactNode;
  customFooter?: ReactNode;
  noFooter?: boolean;
}

const ActionModal: FC<ActionModalProps> = ({
  isModalVisible,
  setIsModalVisible,
  title = "WARNING!",
  type,
  description,
  actionLabel = "PROCEED",
  loading,
  action,
  children,
  customFooter,
  noFooter
}) => {
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title={false}
      width={550}
      footer={false}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      closable={false}
      centered
      maskClosable={!loading}
    >
      <div className="m-10">
        <div className="text-2xl font-bold text-ox-dark mb-10">
          <G_Text weight="semibold" dimension="medium">
            {title?.toUpperCase()}
          </G_Text>
        </div>
        <div className="w-[100%] mb-10">
          {children ||
            description ||
            "This action is not reversible, please make sure you really want to proceed with this action!"}
        </div>

        {customFooter ||
          (!noFooter && (
            <div className="flex items-center justify-between ">
              <G_Button
                form="new-check-group"
                type="default"
                borderColor="ox_2_transparent"
                onClick={handleCancel}
              >
                Discard
              </G_Button>

              <G_Button
                iconSrc={
                  type === "danger"
                    ? "/icons/check.svg"
                    : "/icons/check-black.svg"
                }
                htmlType="submit"
                form="new-check-group"
                bg={type === "danger" ? "ox_2_red" : "ox_2_primary"}
                color={type === "danger" ? "ox_2_white" : "ox_2_black"}
                loading={loading}
                onClick={action}
              >
                {actionLabel}
              </G_Button>
            </div>
          ))}
      </div>
    </Modal>
  );
};

export default ActionModal;
